export default __webpack_public_path__ + "static/media/reporting.fb2fad22.png";